import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ContextualField, Miniature, PropertyType, State, StateDto } from '../../../models';
import { IStateService, ILoggerService, IStoreService } from '../../../services';
import { StoreElement } from '../../../stateManagement';
import { Name, LongComment } from '../../../common/helpers/contextual/predefinedContextualFields';

class ModernStateContextualController implements angular.IComponentController {
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    miniatures: Miniature[];
    properties: ContextualField[];
    selectedItemBackup: StateDto;
    states: State[];

    readonly onCancel: () => void;
    readonly selectedItem: StateDto;

    private _unsubscribe: () => void;

    static $inject = [
        'loggerService',
        'stateService',
        'storeService'
    ];

    constructor(
        private _loggerService: ILoggerService,
        private _stateService: IStateService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.miniatures = [
            {
                type: 'State',
                title: 'State',
                create: () => { },
                highlights: ['A new state'],
                icon: 'fa-barcode',
                sortingOrder: 0,
                group: ''
            }
        ];

        this.properties = [
            Object.assign({}, Name),
            Object.assign({}, LongComment),
            {
                modelName: 'markerColorString',
                propertyType: PropertyType.Color,
                propertyName: 'markerColorStringProperty',
                label: 'Color',
                placeholder: 'Color',
                icon: 'fa-square',
                required: true
            },
            {
                modelName: 'icon',
                propertyType: PropertyType.Background,
                label: 'Icon',
                propertyName: 'iconProperty',
                required: false,
                icon: 'fa-picture-o',
                extraData: {
                    target: '#selectImageModal'
                }
            }
        ];

        this._unsubscribe = this._storeService.register(store => {
            this.states = _.values(store.states.dictionary);
        }, [StoreElement.States]);
    }

    $onChanges(changesObj: angular.IOnChangesObject): void {
        if (changesObj['selectedItem']) {
            this.selectedItemBackup = angular.copy(this.selectedItem);
        }
    }

    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    save() {
        return this._storeService.dispatchers().states.updateOne(this.selectedItem)
            .then(_data => {
                this.selectedItemBackup = angular.copy(this.selectedItem);
                this._loggerService.logSuccess('State successfully updated.');
                this.formController.$setPristine();
            })
            .catch(() => {
                this._loggerService.logError('Failed to save state.');
            });
    }

    cancel(): void {
        (Object as any).assign(this.selectedItem, this.selectedItemBackup);
        this._stateService
            .getByGuid(this.selectedItem.state.guid)
            .then(_data => {
                this.formController.$setPristine();
                if(this.onCancel){
                    this.onCancel();
                }
            });
    }

    validateName() {
        const isValid = !_.some(
            this.states,
            s => s.name.toLowerCase() === this.formController.nameProperty.$viewValue.toLowerCase() && s.guid !== this.selectedItem.state.guid
        );
        this.formController.nameProperty.$setValidity('duplicate', isValid);
    }
}

export const wtModernStateContextual: ComponentDefinition = {
    componentId: 'wtModernStateContextual',
    controller: ModernStateContextualController,
    template: require('./modernStateContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        onCancel: '&?',
        selectedItem: '<'
    }
};
